/**
 * Development-only virtual keyboard. The production bundle never mounts it.
 */
import { createApp } from 'vue'

export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return

  const host = document.createElement('div')
  host.id = 'dev-virtual-keyboard-host'
  document.body.appendChild(host)

  void import('~/components/dev/DevVirtualKeyboard.vue').then((mod) => {
    createApp(mod.default).mount(host)
  })
})
